<template>
  <!-- Navbar -->
  <nav
    class="main-header navbar navbar-expand navbar-light border-bottom"
    style="background-color: #000000"
  >
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <!--
      <li class="nav-item">
        <a
          class="nav-link"
          data-widget="pushmenu"
          @click="openNav"
        >
          <i class="fa fa-bars" />
        </a>
      </li>
      -->
      <li>
        <a
          class="nav-link"
          data-toggle="dropdown"
          title="Home"
          @click="toHome"
        >
          <h4 class="orange tag">ACH Frame Shop</h4>
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <!--
      <li
        v-if="user_id != '9'"
        class="nav-item dropdown"
      >
        <a
          class="nav-link"
          data-toggle="dropdown"
          to="/Sample1"
        >
          <i class="fa fa-user white" />
        </a>
      </li>
      -->
      <li class="nav-item dropdown">
        <!--<a
          class="nav-link tag"
          data-toggle="dropdown"
          title="Shopping Cart"
          @click="toShoppingCart"
        >
          <i
            class="fa fa-shopping-cart orange fa-2x"
            aria-hidden="true"
          />
          <p class="orange">{{ cart.length }}</p>
        </a>-->
        <b-button
          variant="none"
          class="orange"
          @click="doSwitchLang('EN')"
        >
          EN
        </b-button>
      </li>
      <li class="nav-item dropdown">
        <!--<a
          class="nav-link tag"
          data-toggle="dropdown"
          title="Shopping Cart"
          @click="toShoppingCart"
        >
          <i
            class="fa fa-shopping-cart orange fa-2x"
            aria-hidden="true"
          />
          <p class="orange">{{ cart.length }}</p>
        </a>-->
        <b-button
          variant="none"
          class="orange"
          @click="doSwitchLang('CHI')"
        >
          CH
        </b-button>
      </li>
      <li class="nav-item dropdown">
        <!--<a
          class="nav-link tag"
          data-toggle="dropdown"
          title="Shopping Cart"
          @click="toShoppingCart"
        >
          <i
            class="fa fa-shopping-cart orange fa-2x"
            aria-hidden="true"
          />
          <p class="orange">{{ cart.length }}</p>
        </a>-->
        <b-avatar
          class="tag"
          pill
          variant="none"
          style="color: orange;"
          :badge="$store.state.OnlineShop.cart.length.toString()"
          badge-top
          badge-variant="secondary"
        >
          <i
            class="fa fa-shopping-cart fa-2x"
            @click="toShoppingCart"
          />
        </b-avatar>
      </li>
      <!--
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          title="Login as admin"
          @click="toLogin"
        >
          <i
            class="fa fa-sign-in"
            aria-hidden="true"
          />
        </a>
      </li>
      -->
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      lang: 'EN',
      username: localStorage.getItem('fs_user'),
      user_id: localStorage.getItem('fs_user_id'),
      fs_username: localStorage.getItem('fs_username')
    }
  },
  computed: {
    cart () {
      return this.$store.state.OnlineShop.cart
    }
  },
  mounted () {
    if (localStorage.fs_lang) {
      this.lang = localStorage.fs_lang
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout', this.authInfo)
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    toHome () {
      if (this.$route.name !== 'HomePage') this.$router.push({ name: 'HomePage' })
      else this.$router.go()
    },
    toShoppingCart () {
      if (this.$route.name !== 'ShoppingCart') this.$router.push({ name: 'ShoppingCart' })
      else this.$router.go()
    },
    toLogin () {
      this.$router.push({ name: 'Login' })
    },
    doSwitchLang (val) {
      this.lang = val
      localStorage.setItem('fs_lang', this.lang)
      this.$router.go()
    }
  }
}
</script>

<style scoped>
.tag {
  cursor: pointer;
}
.white {
  color: white;
}
.orange {
  font-family: 'Poiret One';
  font-weight: 600;
  color:orange;
}
</style>
